// DataArrayNode.js
import React from "react";
import { Handle } from "reactflow";

const statusStyles = {
  idle: "",
  pending: "border-yellow-400",
  queued: "border-blue-400",
  failed: "border-red-500",
  success: "border-green-500",
  running: "animate-[pulse_1s_infinite] border-green-500",
  approvalNeeded: "animate-[glow_1.5s_infinite] border-orange-500",
  diagnosing: "animate-[pulse_1s_infinite] border-purple-500", // 👈 new line
};

const DataArrayNode = ({ id, data }) => {
  const status = data?.status || "idle";
  return (
    <div
      className={`relative p-4 bg-zinc-800 rounded-lg shadow-md border text-zinc-100 ${statusStyles[status] || ""}`}
    >
      {/* Animated border for status feedback */}
      <div className={`absolute inset-0 rounded-lg pointer-events-none ${statusStyles[status] || ""}`} />
      <div className="flex items-center gap-2">
        <h3 className="font-bold text-lg">
          {data?.label || "Data Array"} {id}
        </h3>
      </div>
      <Handle type="target" position="left" className="bg-blue-400" />
      <Handle type="source" position="right" className="bg-blue-400" />
    </div>
  );
};

export default DataArrayNode;
